import React from "react"
import { Navigation } from "@kit/design/navigation"
import { Icon } from "@kit/design/icon"
import { useCurrentUser } from "hooks/use-current-user"
import { useFeature } from "hooks/use-feature"
import { SIGNALS_STATE } from "pages/signals/constants"

export function SignalsNavItem({ renderLink, trackClick }) {
  const { enabled: featureEnabled } = useFeature.static(
    "signals_in_app_expansion"
  )
  const { signalsAccessLevel } = useCurrentUser()
  const state = signalsAccessLevel?.state

  if (!featureEnabled) return null

  let badge
  let trailing
  switch (state) {
    case SIGNALS_STATE.NON_PRO:
    case SIGNALS_STATE.PRO_TRIAL:
      badge = "pro"
      break
    case SIGNALS_STATE.ENRICHING:
    case SIGNALS_STATE.IN_ENRICHMENT_QUEUE:
      trailing = <Icon name="repeat" size="xs" />
      break
  }

  return (
    <Navigation.Item
      leading="signals"
      label="Subscriber Signals"
      tooltip="See your subscribers' demographics and social influence"
      badge={badge}
      trailing={trailing}
      pathPrefix="/signals"
      render={renderLink(
        "/signals",
        trackClick("Subscriber Signals", undefined, undefined, {
          signals_state: state
        })
      )}
    />
  )
}
